import { render, staticRenderFns } from "./VDependencyRenderer.vue?vue&type=template&id=58f8170a&"
import script from "./VDependencyRenderer.vue?vue&type=script&lang=js&"
export * from "./VDependencyRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports